/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_User_Settings_UpdateInputs */

const cs_audit_key_user_settings_update = /** @type {(inputs: Audit_Key_User_Settings_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatelské nastavení upraveno`)
};

const en_audit_key_user_settings_update = /** @type {(inputs: Audit_Key_User_Settings_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User settings updated`)
};

/**
* | output |
* | --- |
* | "User settings updated" |
*
* @param {Audit_Key_User_Settings_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_user_settings_update = /** @type {((inputs?: Audit_Key_User_Settings_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_User_Settings_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_user_settings_update(inputs)
	return cs_audit_key_user_settings_update(inputs)
});